export default "__VITE_ASSET__556b2a03__"